import { createTranslationRef } from '@backstage/frontend-plugin-api';

export const gitflicPipelinesTranslationRef = createTranslationRef({
  id: 'plugin-gitflic-pipelines',
  messages: {
    header: {
      allPipelines: 'All Pipelines',
      branch: 'Branch',
      tag: 'Tag',
      chooseBranch: 'Choose branch',
      chooseTag: 'Choose tag',
      runPipeline: 'Run Pipeline',
      refresh: 'Refresh pipelines',
    },
    sections: {
      pipelines: 'Pipelines',
      pipelinesTab: 'Pipelines',
      jobsTab: 'Jobs',
      jobs: 'Jobs for pipeline #{{localId}}',
      artifacts: 'Artifacts',
    },
    filters: {
      status: 'Status',
    },
    common: {
      yes: 'Yes',
      no: 'No',
    },
    issues: {
      title: 'Gitflic Issues',
      empty: 'No issues found.',
      status: {
        ALL: 'All',
        OPEN: 'Open',
        IN_PROGRESS: 'In progress',
        CLOSED: 'Canceled',
        COMPLETED: 'Completed',
      },
      table: {
        localId: 'Issue',
        title: 'Title',
        status: 'Status',
        assignees: 'Assignees',
        createdAt: 'Created At',
        updatedAt: 'Updated At',
      },
    },
    mergeRequests: {
      title: 'Gitflic Merge Requests',
      empty: 'No merge requests found.',
      status: {
        ALL: 'All',
        OPENED: 'Open',
        CLOSED: 'Closed',
        MERGED: 'Merged',
        CANCELED: 'Canceled',
      },
      table: {
        localId: 'Merge Request',
        title: 'Title',
        status: 'Status',
        sourceBranch: 'Source Branch',
        targetBranch: 'Target Branch',
        author: 'Author',
        reviewers: 'Reviewers',
        canMerge: 'Can Merge',
        hasConflicts: 'Has Conflicts',
        createdAt: 'Created At',
        updatedAt: 'Updated At',
      },
    },
    table: {
      pipelineId: 'Pipeline',
      status: 'Status',
      branch: 'Branch',
      tag: 'Tag',
      url: 'URL',
      pipelineLink: 'Pipeline {{id}}',
      createdAt: 'Created At',
      startedAt: 'Started At',
      duration: 'Duration',
      actions: 'Actions',
      name: 'Name',
      stage: 'Stage',
      finishedAt: 'Finished At',
      job: 'Job',
      file: 'File',
      size: 'Size',
      expiresAt: 'Expires At',
    },
    actions: {
      jobs: 'Jobs',
      restart: 'Restart',
      cancel: 'Cancel',
      delete: 'Delete',
    },
    dialog: {
      title: 'Run Gitflic Pipeline',
      description:
        'Review and edit CI/CD variables before starting the pipeline.',
      selectedBranch: 'Selected branch: {{name}}',
      selectedTag: 'Selected tag: {{name}}',
      loadingVariables: 'Loading CI/CD variables...',
      noVariables:
        'No predefined CI/CD variables found. You can still add your own variables below.',
      variableKey: 'Variable name',
      variableValue: 'Variable value',
      variableKeyRequired: 'Variable name is required.',
      environmentScope: 'Environment scope: {{scope}}',
      maskedVariable: 'Masked variable',
      addVariable: 'Add variable',
      removeVariable: 'Remove variable',
      cancel: 'Cancel',
      submit: 'Run Pipeline',
      submitting: 'Starting...',
    },
    status: {
      CREATED: 'Created',
      PENDING: 'Pending',
      WAITING_FOR_RESOURCE: 'Waiting for resource',
      RUNNING: 'Running',
      SUCCESS: 'Success',
      FAILED: 'Failed',
      CANCELED: 'Canceled',
      SKIPPED: 'Skipped',
      MANUAL: 'Manual',
      WARNING: 'Warning',
    },
    duration: {
      secondShort: 'sec',
      minuteShort: 'min',
      hourShort: 'h',
      dayShort: 'd',
    },
    state: {
      missingAnnotation: 'Entity is missing {{annotation}}',
      invalidProjectSlug:
        'Expected Gitflic project slug in format owner/project, got "{{projectSlug}}".',
      noPipelines: 'No pipelines found for the selected branch.',
      noJobs: 'No jobs found for the selected pipeline.',
      noPipelineSelected: 'Select a pipeline to view its jobs.',
      noBranches: 'No branches found.',
      noTags: 'No tags found.',
      emptyValue: '-',
      pipelinesAccessDenied: {
        title: 'Pipeline and job access is restricted',
        description:
          'Reason: check your permissions or contact an administrator.',
      },
      gitflicAccessDenied: {
        title: 'Gitflic access is restricted',
        description:
          'Reason: check your permissions or contact an administrator.',
      },
    },
  },
  translations: {},
});
